import {
    SellerFeedbackReason,
} from "./SellerFeedbackTypes";

export const sellerFeedbackReasons: SellerFeedbackReason[] = [
    {
        id: "delivery",
        label: "Delivery experience",
        description: "Dispatch timing, hand-off or seller-controlled fulfilment experience.",
    },
    {
        id: "packaging",
        label: "Packaging",
        description: "Packaging quality, protection and presentation of the shipment.",
    },
    {
        id: "listing",
        label: "Listing accuracy",
        description: "Whether the seller supplied the correct item, variant and represented condition.",
    },
    {
        id: "communication",
        label: "Seller communication",
        description: "Clarity, helpfulness and response quality when contacting the seller.",
    },
    {
        id: "resolution",
        label: "Issue resolution",
        description: "How effectively the seller handled an order-related concern.",
    },
    {
        id: "other",
        label: "Something else",
        description: "Another seller-service experience related to this order.",
    },
];
